import React, { useState, useEffect } from "react";
import { NavMenu } from "components/organisms/NavMenu";
import { Header } from "components/organisms/Header";
import withInteractionData from "hoc/withInteractionData";
import withFeatureFlags from "hoc/withFeatureFlags";
import JsaNotification from "components/organisms/JsaNotification/JsaNotification";
import { useLocation } from "react-router-dom";
import { HedisPopUps } from "components/molecules/HedisPopUps/HedisPopUps";
import { Box, Container } from "@mui/material";
import withMemberData from "hoc/withMemberData";
import { MemberPortalConfigProvider } from "contexts/MemberPortalConfigContext";
import { BannerList } from "components/organisms/BannerList/BannerList";
import { PDFViewerProvider } from "contexts/PdfViewerContext";
import { PDFViewer } from "components/organisms/PDFViewer";

const SHOW_HEDIS_CAMPAIGNS_POP_UPS_FEATURE_FLAG = "show-hedis-campaigns-popups";
const jsaRoute = "/jsa-appointment-request";
const messageCenterRoute = "/message-center";

export const Layout = (props) => {
  const [displayJsa, setDisplayJsa] = useState(true);

  const location = useLocation();

  useEffect(() => {
    if (location?.pathname == jsaRoute) {
      setDisplayJsa(false);
    } else {
      setDisplayJsa(true);
    }
  }, [location?.pathname]);

  return (
    <div className="main-content">
      <MemberPortalConfigProvider member={props.member}>
        <PDFViewerProvider>
          <PDFViewer />
          <Header {...props} />
          <NavMenu {...props} />
          <Container>
            {!props.member?.termed && (
              <Box rowGap={2}>
                <BannerList paddingTop={4} />
                <HedisPopUps />
                {displayJsa && <JsaNotification member={props.member} />}
              </Box>
            )}
            {props.children}
          </Container>
        </PDFViewerProvider>
      </MemberPortalConfigProvider>
    </div>
  );
};

export default withFeatureFlags(withInteractionData(withMemberData(Layout)));
